// extracted by mini-css-extract-plugin
export default {"host":"style_host__beg-M","plainLabel":"style_plainLabel__Flmhw","description":"style_description__bYHC9","notes":"style_notes__QtKnV"};